/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2024 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use client";
import * as t from "react";
import { useIsomorphicLayoutEffect as l, COLLECTION_ACTION as c } from "@progress/kendo-react-common";
import { useSchedulerViewItemsContext as p } from "../context/SchedulerViewContext.mjs";
const f = (n, o) => {
  const { _ref: a, itemRef: i, _maxSiblingsPerSlot: r } = n, e = t.useRef(null), u = t.useRef(null), [, m] = p();
  return t.useImperativeHandle(e, () => ({
    element: u.current,
    props: n,
    get _maxSiblingsPerSlot() {
      var s;
      return (s = r == null ? void 0 : r.current) != null ? s : 0;
    }
  })), t.useImperativeHandle(o, () => e.current), t.useImperativeHandle(a, () => e.current), t.useImperativeHandle(i, () => e.current), l(() => (m({
    type: c.add,
    item: e
  }), () => {
    m({
      type: c.remove,
      item: e
    });
  })), {
    item: e,
    element: u
  };
};
export {
  f as useSchedulerItem
};
